import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Section } from '../../knowledge-base/Section';
import ArticlesList from '../../knowledge-base/ArticlesList';
import VizExLoadingSpinner from 'visitor-ui-component-library/loading/VizExLoadingSpinner';
import { getCategoryArticles } from '../../knowledge-base/clients/kb-api.v3';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const CategoryArticlesWrapper = styled.div.withConfig({
  displayName: "CategoryArticlesPreview__CategoryArticlesWrapper",
  componentId: "nnyg28-0"
})(["height:100%;overflow-y:scroll;"]);
const LoadingWrapper = styled.div.withConfig({
  displayName: "CategoryArticlesPreview__LoadingWrapper",
  componentId: "nnyg28-1"
})(["display:flex;justify-content:center;align-items:center;height:80%;"]);
export default function CategoryArticlesPreview({
  knowledgeBaseId,
  knowledgeBaseUrl,
  coloring,
  selectedCategory,
  onArticleClick
}) {
  const [articles, setArticles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    const fetchArticles = async () => {
      if (!(selectedCategory !== null && selectedCategory !== void 0 && selectedCategory.categoryId) || !knowledgeBaseId) return;
      setIsLoading(true);
      try {
        const response = await getCategoryArticles({
          categoryId: selectedCategory.categoryId,
          knowledgeBaseId,
          knowledgeBaseUrl
        });
        if (Array.isArray(response)) {
          setArticles(response);
        } else if (Array.isArray(response.results)) {
          setArticles(response.results);
        }
        setIsLoading(false);
      } catch (error) {
        if (error instanceof Error) {
          setIsLoading(false);
          Raven.captureException(error);
        }
      }
    };
    void fetchArticles();
  }, [selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.categoryId, knowledgeBaseId, knowledgeBaseUrl]);
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingWrapper, {
      children: /*#__PURE__*/_jsx(VizExLoadingSpinner, {})
    });
  }
  return /*#__PURE__*/_jsx(CategoryArticlesWrapper, {
    children: /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(ArticlesList, {
        hideSubtitle: true,
        items: articles,
        coloring: coloring,
        onArticleClick: onArticleClick
      })
    })
  });
}
CategoryArticlesPreview.displayName = 'CategoryArticlesPreview';